<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">{{txtLang[curLang]['7mSport']}}</p>
      <div class = "h_btn" >
        <a :class = "noticeNum > 0 ? 'redPoint' : ''" @click="hideSide" href = "javascript:void(0)">
          <img src = "../../static/image/icon_menu.png"/>
        </a>
      </div>
    </div>

    <!--个人信息-->
    <div class = "person" :class = "lx.length != 0 && !lxHide ? '' : 'personTop'">
      <div class = "p_box flex flex-align-center">
        <div class = "pb_left">
          <img src = "../../static/image/icon_coin.png" />
          <p>{{txtLang[curLang]['mCoin']}}</p>
        </div>
        <div v-if = "ifLogin" class = "pb_num flex-1">
          <p>{{moneyStr(curCoin)}}</p>
        </div>
        <div v-else class = "pb_loginBtn flex-1">
          <a @click = "toLoginFn" href = "javascript:void(0);">{{txtLang[curLang]['login']}}</a>
        </div>
        <div class = "pb_btn">
          <router-link :to="{name: 'Mall'}">
            <img src = "../../static/image/icon_market.png" />
            <p>{{txtLang[curLang]['market']}}</p>
          </router-link>
          <router-link :to="{name: 'Lottery'}">
            <img src = "../../static/image/icon_reward.png" />
            <p>{{txtLang[curLang]['reward']}}</p>
          </router-link>
          <router-link :to="{name: 'task'}" :class = "taskRed ? 'redPoint' : ''">
            <img src = "../../static/image/icon_task.png" />
            <p>{{txtLang[curLang]['task']}}</p>
          </router-link>
        </div>
      </div>
    </div>

    <!--轮显-->
    <div class = "lx" :class = "lx.length != 0 && !lxHide ? '' : 'lxHide'" ref="lx">
      <div class = "l_box">
        <lx :arr = "lx"></lx>
      </div>
    </div>

    <!--今日／未来-->
    <div class = "nav1" :class = "lx.length != 0 && !lxHide ? '' : 'nav1Top'">
      <div class = "n_box">
        <ul>
          <li @click = "tab1(0)" :class = "navIndex1 == 0 ? 'on' : ''">{{txtLang[curLang]['today']}}</li>
          <li @click = "tab1(1)" :class = "navIndex1 == 1 ? 'on' : ''">{{txtLang[curLang]['future']}}</li>
        </ul>
        <a @click = "openScreen" class = "nb_btn" :class = "navIndex1 == 0 && ifScreen || navIndex1 == 1 && ifScreen2 ? 'nb_btn_on' : ''" href = "javascript:void(0)"></a>
      </div>
    </div>

    <!--购物车-->
    <div class = "carBg" :class = "carHide ? 'carBgHide' : ''" @click = "closeCar"></div>
    <div v-show = "carArr.length > 0" class = "carBox" :class = "carHide ? 'carHide' : ''">
      <div class = "c_header">
        <span class= "ch_num">{{carArr.length}}</span>
        <span class= "ch_txt">{{txtLang[curLang]['betName']}}<b v-show = "carArr.length >= bet_order_max && carHide">({{txtLang[curLang]['betUpLimit']}})</b></span>
        <a v-show = "carHide" @click = "openCar" class = "ch_btn" href = "javascript:void(0);">{{txtLang[curLang]['bet']}}</a>
      </div>
      <ul class = "c_list">
        <li v-for = "v,index in carArr">
          <a class = "cl_del" @click = "delCarBet(index)" href = "javascript:void(0);"></a>
          <p class = "cl_p1"><span class = "cl_handicap">{{txtLang[curLang]['playType'][v.playTypeId]}}</span><span class = "cl_odds" :class = "v.oddsChange == 0 ? '' : (v.oddsChange > 0 ? 'cl_up' : 'cl_down')">{{txtLang[curLang]['playOption'][v.playTypeId][v.optionIndex]}} {{v.odds}}</span></p>
          <p class = "cl_p2"><span class = "cl_name">{{v.hname}}</span> <span>VS</span> <span class = "cl_name">{{v.aname}}</span> <span class = "cl_handicap">{{v.playTypeId == 1 ? '' : '(' + oddsT(v.handicap,v.playTypeId) + ')'}}</span></p>
          <p class = "cl_p3" v-if = "v.errorType == 7 || v.errorType == 15 || v.errorTxt == ''">
            <span class = "cl_r" v-html = "txtLang[curLang].winCoinBack(moneyStr(calBack(v.playTypeId,v.coin,v.odds)))"></span>
            <span >{{txtLang[curLang].bet}}</span>
            <span class = "cl_input">{{moneyStr(v.coin)}}</span>
          </p>
          <p class = "cl_p4">{{v.errorTxt}}</p>
        </li>
      </ul>
      <div class = "c_total">
        <div class = "ct_txt">
          <div>
            <p class = "p1">{{txtLang[curLang].totalBet}}</p>
            <p class = "p2">{{moneyStr(carTotalBet)}}</p>
          </div>
          <div>
            <p class = "p3">{{txtLang[curLang].totalBack}}</p>
            <p class = "p4">{{moneyStr(carTotalBack)}}</p>
          </div>
        </div>
        <div class = "ct_btn">
          <a @click = "toBet" href = "javascript:void(0)">{{txtLang[curLang].bet}}</a>
        </div>
      </div>
    </div>

    <!--联赛筛选-今日 -->
    <div class = "carBg carBgHigher" :class = "screenHide ? 'carBgHide' : ''" @click = "cancelScreen"></div>
    <div class = "screenBox" :class = "screenHide ? 'screenBoxHide' : ''">
      <p class = "s_title">{{txtLang[curLang]['leagueScreen']}}</p>
      <ul class = "s_list">
        <li @click = "toggleLeague(index)" :class = "v.on ? 'on' : ''" v-for="(v,index) in league">
          {{ v.name }}
        </li>
      </ul>
      <ul class = "s_radio">
        <li @click = "allScreen" :class = "screenType == 0 ? 'on' : ''">{{txtLang[curLang]['allSelect']}}</li>
        <li @click = "contractScreen" :class = "screenType == 1 ? 'on' : ''">{{txtLang[curLang]['contractSelect']}}</li>
      </ul>
      <div class = "s_btn">
        <a @click = "cancelScreen" class = "br" href = "javascript:void(0);">{{txtLang[curLang]['cancel']}}</a>
        <a @click = "confirmScreen" class = "on" href = "javascript:void(0);">{{txtLang[curLang]['confirm']}}</a>
      </div>
    </div>

    <!--联赛筛选-未来 -->
    <div class = "carBg carBgHigher" :class = "screenHide2 ? 'carBgHide' : ''" @click = "cancelScreen2"></div>
    <div class = "screenBox" :class = "screenHide2 ? 'screenBoxHide' : ''">
      <p class = "s_title">{{txtLang[curLang]['leagueScreen']}}</p>
      <ul class = "s_list">
        <li @click = "toggleLeague2(index)" :class = "v.on ? 'on' : ''" v-for="(v,index) in league2">
          {{ v.name }}
        </li>
      </ul>
      <ul class = "s_radio">
        <li @click = "allScreen2" :class = "screenType2 == 0 ? 'on' : ''">{{txtLang[curLang]['allSelect']}}</li>
        <li @click = "contractScreen2" :class = "screenType2 == 1 ? 'on' : ''">{{txtLang[curLang]['contractSelect']}}</li>
      </ul>
      <div class = "s_btn">
        <a @click = "cancelScreen2" class = "br" href = "javascript:void(0);">{{txtLang[curLang]['cancel']}}</a>
        <a @click = "confirmScreen2" class = "on" href = "javascript:void(0);">{{txtLang[curLang]['confirm']}}</a>
      </div>
    </div>

    <!--今日-->
    <div v-if = "navIndex1 == 0" class = "body" :class = "lx.length == 0 ? 'bodyTop' : ''">
      <ul  class = "nav2">
        <li class = "br" @click = "tab2(0)" :class = "navIndex2 == 0 ? 'on' : ''">{{txtLang[curLang]['hot']}}</li>
        <li @click = "tab2(1)" :class = "navIndex2 == 1 ? 'on' : ''">{{txtLang[curLang]['new']}}</li>
      </ul>

      <div v-if = "league.length > 0" class = "listBox">
        <!--热门列表-->
        <ul class = "l_list" v-if = "navIndex2 == 0 && listHot.length > 0">
          <li v-for = "v,index in listHot">
            <div class = "l_league">{{v.name}}</div>
            <div class = "l_matchBox" :class = "!v.all ? 'l_matchBoxHide' : ''">
              <div v-for = "v2,index2 in v.game_list" class = "l_match">
                <div class = "l_info flex flex-align-center">
                  <div class = "l_datetime">
                    <p>{{dateStrPower(v2.time,4).split(' ')[0]}}</p>
                    <p>{{dateStrPower(v2.time,4).split(' ')[1]}}</p>
                  </div>
                  <div class = "flex-1">
                    <div class = "l_team"><img :src = "v2.home_team_logo"/><span>{{v2.home_team_name}}</span></div>
                    <div class = "l_team"><img :src = "v2.away_team_logo"/><span>{{v2.away_team_name}}</span></div>
                  </div>  
                </div>
                <div v-for = "v3,index3 in v2.play_type" :class = "listHotOther[v2.id][v3.id]['seal_status'] != 1 ? 'l_disable' : ''" class = "flex">
                  <div v-if = "v3.id == 1" class = "l_type flex flex-v flex-align-center flex-pack-center">
                    <p>{{txtLang[curLang]['playType'][v3.id]}}</p>
                  </div>
                  <div v-else class = "l_type flex flex-v flex-align-center flex-pack-center">
                    <p>{{txtLang[curLang]['playType'][v3.id]}}</p>
                    <p class = "lt_handicap">({{oddsT(v3.value,v3.id)}})</p>
                  </div>

                  <div @click = "addCar(1,v2.id,v3.id,0,v3.option[0].id,listHotOther[v2.id][v3.id]['odds_0'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listHotOther[v2.id][v3.id]['isbet_0'] != 1 ? 'l_select' : '',listHotDeal[v2.id][v3.id]['select_0'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listHotOther[v2.id][v3.id]['oddsChange_0'] == 0 ? '' : (listHotOther[v2.id][v3.id]['oddsChange_0'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v2.id][v3.id]['odds_0']}}{{listHotOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][0]}}</span>
                  </div>
                  <div @click = "addCar(1,v2.id,v3.id,2,v3.option[2].id,listHotOther[v2.id][v3.id]['odds_2'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listHotOther[v2.id][v3.id]['isbet_2'] != 1 ? 'l_select' : '',listHotDeal[v2.id][v3.id]['select_2'] ? 'l_bet' : '']" v-if = "v3.id == 1" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listHotOther[v2.id][v3.id]['oddsChange_2'] == 0 ? '' : (listHotOther[v2.id][v3.id]['oddsChange_2'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v2.id][v3.id]['odds_2']}}{{listHotOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][2]}}</span>
                  </div>
                  <div @click = "addCar(1,v2.id,v3.id,1,v3.option[1].id,listHotOther[v2.id][v3.id]['odds_1'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listHotOther[v2.id][v3.id]['isbet_1'] != 1 ? 'l_select' : '',listHotDeal[v2.id][v3.id]['select_1'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listHotOther[v2.id][v3.id]['oddsChange_1'] == 0 ? '' : (listHotOther[v2.id][v3.id]['oddsChange_1'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v2.id][v3.id]['odds_1']}}{{listHotOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][1]}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class = "l_sh" :class = "!v.all ? 'l_down' : ''" @click = "listSH(index)">
            </div>
          </li>
        </ul>
        <!--最新列表-->
        <ul class = "l_list" v-else-if = "navIndex2 == 1 && listNew.length > 0">
          <li v-for = "v,index in listNew">
            <div class = "l_league">{{v.competition_name}}</div>
            <div class = "l_info flex flex-align-center">
              <div class = "l_datetime">
                <p>{{dateStrPower(v.time,4).split(' ')[0]}}</p>
                <p>{{dateStrPower(v.time,4).split(' ')[1]}}</p>
              </div>
              <div class = "flex-1">
                <div class = "l_team"><img :src = "v.home_team_logo"/><span>{{v.home_team_name}}</span></div>
                <div class = "l_team"><img :src = "v.away_team_logo"/><span>{{v.away_team_name}}</span></div>
              </div>  
            </div>
            <div class = "flex" v-for = "v2,index2 in v.play_type" :class = "listHotOther[v.id][v2.id]['seal_status'] != 1 ? 'l_disable' : ''">
              <div v-if = "v2.id == 1" class = "l_type flex flex-v flex-align-center flex-pack-center">
                <p>{{txtLang[curLang]['playType'][v2.id]}}</p>
              </div>
              <div v-else class = "l_type flex flex-v flex-align-center flex-pack-center">
                <p>{{txtLang[curLang]['playType'][v2.id]}}</p>
                <p class = "lt_handicap">({{oddsT(v2.value,v2.id)}})</p>
              </div>
              <div @click = "addCar(1,v.id,v2.id,0,v2.option[0].id,listHotOther[v.id][v2.id]['odds_0'],v.home_team_name,v.away_team_name,v2.value,v2.bet_status,v2.seal_status)" :class = "[listHotOther[v.id][v2.id]['isbet_0'] != 1 ? 'l_select' : '',listHotDeal[v.id][v2.id]['select_0'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                <span :class = "listHotOther[v.id][v2.id]['oddsChange_0'] == 0 ? '' : (listHotOther[v.id][v2.id]['oddsChange_0'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v.id][v2.id]['odds_0']}}{{listHotOther[v.id][v2.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                <span class = "lo_bet">{{txtLang[curLang]['playOption'][v2.id][0]}}</span>
              </div>
              <div @click = "addCar(1,v.id,v2.id,2,v2.option[2].id,listHotOther[v.id][v2.id]['odds_2'],v.home_team_name,v.away_team_name,v2.value,v2.bet_status,v2.seal_status)" :class = "[listHotOther[v.id][v2.id]['isbet_2'] != 1 ? 'l_select' : '',,listHotDeal[v.id][v2.id]['select_2'] ? 'l_bet' : '']" v-if = "v2.id == 1" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                <span :class = "listHotOther[v.id][v2.id]['oddsChange_2'] == 0 ? '' : (listHotOther[v.id][v2.id]['oddsChange_2'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v.id][v2.id]['odds_2']}}{{listHotOther[v.id][v2.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                <span class = "lo_bet">{{txtLang[curLang]['playOption'][v2.id][2]}}</span>
              </div>
              <div @click = "addCar(1,v.id,v2.id,1,v2.option[1].id,listHotOther[v.id][v2.id]['odds_1'],v.home_team_name,v.away_team_name,v2.value,v2.bet_status,v2.seal_status)" :class = "[listHotOther[v.id][v2.id]['isbet_1'] != 1 ? 'l_select' : '',,listHotDeal[v.id][v2.id]['select_1'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                <span :class = "listHotOther[v.id][v2.id]['oddsChange_1'] == 0 ? '' : (listHotOther[v.id][v2.id]['oddsChange_1'] > 0 ? 'lo_up' : 'lo_down')">{{listHotOther[v.id][v2.id]['odds_1']}}{{listHotOther[v.id][v2.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                <span class = "lo_bet">{{txtLang[curLang]['playOption'][v2.id][1]}}</span>
              </div>
            </div>
          </li>
        </ul>
        <div v-else-if = "navIndex2 == 0 && listHot.length == 0 || navIndex2 == 1 && listNew.length == 0" class = "noMatch">
          <img src = "../../static/image/noMatch.png"/>
          <p>{{txtLang[curLang]['noMatch']}}</p>
        </div>
      </div>
      <!--缺省-->
      <div v-else class = "noMatch">
        <img src = "../../static/image/noMatch.png"/>
        <p>{{txtLang[curLang]['noMatch']}}</p>
      </div>
    </div>

    <!--未来6天-->
    <div v-else class = "body" :class = "lx.length == 0 ? 'bodyTop' : ''">
      <ul  class = "flex nav3">
        <li class = "n_date flex flex-align-center">
          <p v-html = "curMonth"></p>
        </li>
        <li @click = "tabDate(index)" v-for = "v,index in futureDate" class = "flex-1" :class = "futureIndex == index ? 'on' : ''">
          <p>{{transformDay(index)}}</p>
        </li>
      </ul>

      <div v-if = "league2.length > 0" class = "listBox">
        <!--列表-->
        <ul class = "l_list" v-if = "listFuture.length > 0">
          <li v-for = "v,index in listFuture">
            <div class = "l_league">{{v.name}}</div>
            <div class = "l_matchBox" :class = "!v.all ? 'l_matchBoxHide' : ''">
              <div v-for = "v2,index2 in v.game_list" class = "l_match">
                <div class = "l_info flex flex-align-center">
                  <div class = "l_datetime">
                    <p>{{dateStrPower(v2.time,4).split(' ')[0]}}</p>
                    <p>{{dateStrPower(v2.time,4).split(' ')[1]}}</p>
                  </div>
                  <div class = "flex-1">
                    <div class = "l_team"><img :src = "v2.home_team_logo"/><span>{{v2.home_team_name}}</span></div>
                    <div class = "l_team"><img :src = "v2.away_team_logo"/><span>{{v2.away_team_name}}</span></div>
                  </div>  
                </div>
                <div v-for = "v3,index3 in v2.play_type" :class = "listFutureOther[v2.id][v3.id]['seal_status'] != 1 ? 'l_disable' : ''" class = "flex">
                  <div v-if = "v3.id == 1" class = "l_type flex flex-v flex-align-center flex-pack-center">
                    <p>{{txtLang[curLang]['playType'][v3.id]}}</p>
                  </div>
                  <div v-else class = "l_type flex flex-v flex-align-center flex-pack-center">
                    <p>{{txtLang[curLang]['playType'][v3.id]}}</p>
                    <p class = "lt_handicap">({{oddsT(v3.value,v3.id)}})</p>
                  </div>

                  <div @click = "addCar(2,v2.id,v3.id,0,v3.option[0].id,listFutureOther[v2.id][v3.id]['odds_0'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listFutureOther[v2.id][v3.id]['isbet_0'] != 1 ? 'l_select' : '',listFutureDeal[v2.id][v3.id]['select_0'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listFutureOther[v2.id][v3.id]['oddsChange_0'] == 0 ? '' : (listFutureOther[v2.id][v3.id]['oddsChange_0'] > 0 ? 'lo_up' : 'lo_down')">{{listFutureOther[v2.id][v3.id]['odds_0']}}{{listFutureOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][0]}}</span>
                  </div>
                  <div @click = "addCar(2,v2.id,v3.id,2,v3.option[2].id,listFutureOther[v2.id][v3.id]['odds_2'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listFutureOther[v2.id][v3.id]['isbet_2'] != 1 ? 'l_select' : '',listFutureDeal[v2.id][v3.id]['select_2'] ? 'l_bet' : '']" v-if = "v3.id == 1" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listFutureOther[v2.id][v3.id]['oddsChange_2'] == 0 ? '' : (listFutureOther[v2.id][v3.id]['oddsChange_2'] > 0 ? 'lo_up' : 'lo_down')">{{listFutureOther[v2.id][v3.id]['odds_2']}}{{listFutureOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][2]}}</span>
                  </div>
                  <div @click = "addCar(2,v2.id,v3.id,1,v3.option[1].id,listFutureOther[v2.id][v3.id]['odds_1'],v2.home_team_name,v2.away_team_name,v3.value,v3.bet_status,v3.seal_status)" :class = "[listFutureOther[v2.id][v3.id]['isbet_1'] != 1 ? 'l_select' : '',listFutureDeal[v2.id][v3.id]['select_1'] ? 'l_bet' : '']" class = "l_odds flex flex-align-center flex-pack-center flex-1">
                    <span :class = "listFutureOther[v2.id][v3.id]['oddsChange_1'] == 0 ? '' : (listFutureOther[v2.id][v3.id]['oddsChange_1'] > 0 ? 'lo_up' : 'lo_down')">{{listFutureOther[v2.id][v3.id]['odds_1']}}{{listFutureOther[v2.id][v3.id]['seal_status'] != 1 ? '(' + txtLang[curLang]['locked'] + ')' : ''}}</span>
                    <span class = "lo_select">{{txtLang[curLang]['select']}}</span>
                    <span class = "lo_bet">{{txtLang[curLang]['playOption'][v3.id][1]}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class = "l_sh" :class = "!v.all ? 'l_down' : ''" @click = "listSH2(index)">
            </div>
          </li>
        </ul>
        <div v-else class = "noMatch">
          <img src = "../../static/image/noMatch.png"/>
          <p>{{txtLang[curLang]['noMatch']}}</p>
        </div>
      </div>
      <!--缺省-->
      <div v-else class = "noMatch">
        <img src = "../../static/image/noMatch.png"/>
        <p>{{txtLang[curLang]['noMatch']}}</p>
      </div>
    </div>

    <!--alert层-->
    <Alert ref="Alert" :txt = "alertTip"/>
    <!--侧边栏-->
    <sideBar ref="Model"></sideBar>
    <!--错误提示-->
    <div class = "popBox" v-show = "popSH">
      <div class = "p_box">
        <div class = "pb_body flex flex-align-center">
          <p v-html = "popErrorTxt"></p>
        </div>
        <div class = "pb_btn">
          <a @click = "popSH=false;" href = "javascript:void(0)">{{txtLang[curLang]['close']}}</a>
        </div>
      </div>
    </div>
    <!--请求错误提示-->
    <div class = "popBox" v-show = "popSH2">
      <div class = "p_box">
        <div class = "pb_body flex flex-align-center">
          <div style = "width:100%">
            <p class = "pb_fail">{{txtLang[curLang].betFail}}</p>
            <p class = "pb_tip">{{txtLang[curLang].betFailTxt}}</p>
          </div>
        </div>
        <div class = "pb_btn">
          <a @click = "popSH2=false;" href = "javascript:void(0)">{{txtLang[curLang]['know']}}</a>
        </div>
      </div>
    </div>
    <!--成功提示-->
    <div class = "popBox" v-show = "popSH3">
      <div class = "p_box">
        <div class = "pb_body flex flex-align-center">
          <p class = "pb_success">{{txtLang[curLang].betSuccess}} </p>
        </div>
        <div class = "pb_btn pb_btn2">
          <a class = "on" @click = "toOrder" href = "javascript:void(0)">{{txtLang[curLang]['guessHistory']}}</a>
          <a @click = "popSH3=false;" href = "javascript:void(0)">{{txtLang[curLang]['goOnGuess']}}</a>
        </div>
      </div>
    </div>
    <!--上传中-->
    <div class = "popBox" v-show = "popSH4">
      <div class = "p_box p_loading">
        <img src = "../../static/image/upload.gif"/>
        <p>{{txtLang[curLang].betting}}...</p>
      </div>
    </div>
    <!--loading层-->
    <LoadingBox v-show = "popSH5"/> 
    <!--引导1-->
    <div class = "popGuide" v-show = "guideSH">
      <div class = "p_box">
        <div class = "pb_head"><img :src = "'../../static/image/Congratulations_' + curLang + '.png'"/></div>
        <a @click = "closeGuide" href = "javascript:void(0);" class = "pb_close"><img src = "../../static/image/guide_close.png"/></a>
        <div class = "pb_title">{{txtLang[curLang].youGot}}</div>
        <div class = "pb_tip flex flex-align-center">
          <div class = "pb_l"><img src = "../../static/image/guide_coin.png"/></div>
          <div class = "pb_r">
            <p class = "pb_p1" v-if = "curLang == 'kr'">{{txtLang[curLang].mCoin}} {{guideCoin}}개</p>
            <p class = "pb_p1" v-else>{{guideCoin}} {{txtLang[curLang].mCoin}}</p>
            <p class = "pb_p2">{{txtLang[curLang].guideP1}}</p>
          </div>
        </div>
        <div class = "pb_tip flex flex-align-center">
          <div class = "pb_l"><img src = "../../static/image/guide_ticket.png"/></div>
          <div class = "pb_r">
            <p class = "pb_p1 pb_p1_purple" v-if = "curLang == 'kr'">{{txtLang[curLang].eM}} {{guideTicket}}장</p>
            <p class = "pb_p1 pb_p1_purple" v-else>{{guideTicket}} {{txtLang[curLang].eM}}</p>
            <p class = "pb_p2">{{txtLang[curLang].guideP2}}</p>
          </div>
        </div>
        <a @click = "toLoginFn" href = "javascript:void(0);" class = "pb_btn pb_mb">{{txtLang[curLang].loginAndGet}}</a>
        <div class = "pb_intro">({{txtLang[curLang].guideP3}})</div>
      </div>
    </div>
    <!--引导2-->
    <div class = "popGuide" v-show = "guideSH2">
      <div class = "p_box">
        <a @click = "closeGuide2" href = "javascript:void(0);" class = "pb_close"><img src = "../../static/image/guide_close.png"/></a>
        <div class = "pb_title2">{{txtLang[curLang].guideP4}}</div>
        <div class = "pb_pic">
          <img src = "../../static/image/guide_pic.png"/>
        </div>
        <router-link :to="{name: 'task'}" class = "pb_btn">{{txtLang[curLang].toFinish}}</router-link>
        <div class = "pb_title2">{{txtLang[curLang].guideP5}}</div>
        <div class = "pb_pic">
          <img src = "../../static/image/guide_pic2.png"/>
        </div>
        <router-link :to="{name: 'Lottery'}" class = "pb_btn pb_mb">{{txtLang[curLang].reward}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Lx from './common/Lx'
import sideBar from './sideBar'
import Alert from './common/Alert'
import qs from 'qs'
import LoadingBox from './common/Loading'

export default {
  name: 'HelloWorld',
  components:{
    Lx,
    sideBar,
    Alert,
    LoadingBox
  },
  data () {
    return {
      websock:null,
      guideSH:false,
      guideSH2:false,
      guideCoin:0,//引导M币
      guideTicket:0,//引导M券
      taskRed:false,//任务红点
      popSH:false,//投注错误弹窗
      popSH2:false,//请求错误弹窗
      popSH3:false,//投注成功弹窗
      popSH4:false,//请求中弹窗
      popSH5:true,//loading
      popErrorTxt:'',
      popErrorBtnTxt:'',
      alertTip:'',//alert文本
      ifLogin:false,//是否登录
      curCoin:0,//当前M币
      scroll:0,//当前滚动条位置
      canBet:1,//是否能投注，1正常2封号
      bet_min:0,
      bet_max:0,
      bet_order_max:0,
      /////////////////////////////////////////////////////////////////////////////////
      //轮显
      lx:[
        // {image:'../../static/image/banner.png',url:'http://www.baidu.com'},
        // {image:'../../static/image/banner.png',url:'javascript:void(0)'},
        // {image:'../../static/image/banner.png',url:'javascript:void(0)'}
      ],
      lxMax:6,//轮显最大值
      lxHide:false,//轮显是否隐藏
      lxHeight:0,//轮显高度
      /////////////////////////////////////////////////////////////////////////////////
      navIndex1:0,//今日/未来
      navIndex2:0,//热门/最新
      /////////////////////////////////////////////////////////////////////////////////
      //购物车
      carArr:[],//购物车数量
      carTotalBet:0,
      carTotalBack:0,
      carHide:true,//购物车是否收起
      limitSh:false,//上限提示,
      /////////////////////////////////////////////////////////////////////////////////
      //筛选窗
      ifScreen:false,//今日-是否筛选
      league:[],//今日-联赛列表
      screenHide:true,//今日-筛选窗是否收起
      screenType:0,//今日-全选/反选
      ifScreen2:false,//未来-是否筛选
      league2:[],//未来-联赛列表
      screenHide2:true,//未来-筛选窗是否收起      
      screenType2:0,//未来-全选/反选
      /////////////////////////////////////////////////////////////////////////////////
      //列表
      listHot:[],//热门列表
      listHotDeal:{},//热门和最新的选中控制
      listHotOther:{},//热门和最新的指数变化、是否投注选中控制
      listNew:[],//最新列表
      listFuture:[],//未来列表
      listFutureDeal:{},//未来选中控制
      listFutureOther:{},//未来的指数变化、是否投注选中控制
      position:0,
      position2:0,
      monthName:['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'],
      curMonth:'',
      futureDate:[],
      futureIndex:0,
      langSh:false,
      socketSt:null,
      socketErrorCount:0
    }
  },
  methods: {
    toLoginFn(){
      this.gotoLogin();
    },
    toLogin(){
      this.ifLogin = false;
    },
    toOrder(){
      this.$router.push({name:'guessOrder'});
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //联赛-今日
    openScreen(){//打开筛选
      if(this.navIndex1 == 0){
        if(this.league.length != 0){
          this.screenHide = false;
        }
      }
      else{
        if(this.league2.length != 0){
          this.screenHide2 = false;
        }
      } 
    },
    closeScreen(){//关闭联赛筛选

      this.screenHide = true;
    },
    allScreen(){//全选
      this.screenType = 0;
      for(var i = 0;i < this.league.length;i++){
        if(!this.league[i].on){
          var obj = this.league[i];
          obj.on = true;
          obj.change = !obj.change;
          this.$set(this.league,i,obj);
        }
      }
    },
    contractScreen(){//反选
      this.screenType = 1;
      for(var i = 0;i < this.league.length;i++){
        var obj = this.league[i];
        obj.on = !obj.on;
        obj.change = !obj.change;
        this.$set(this.league,i,obj);
      }
    },
    confirmScreen(){//确定筛选
      var count = 0;
      for(var i = 0;i < this.league.length;i++){
        if(this.league[i].on){
          count ++;
        }
      }
      if(count == 0){
        this.alertTip = this.txtLang[this.curLang]['screenError'];
        this.$refs.Alert.show();
        return;
      }

      var arr = [];
      var count2 = 0;
      for(var i = 0;i < this.league.length;i++){
        var obj = this.league[i];
        if(this.league[i].on){
          arr.push(obj.id);
          count2 ++;
        }
        obj.change = false;
        this.$set(this.league,i,obj);
      }

      //全选=未筛选
      if(count2 == this.league.length){
        this.delStorage('screenStr');
        this.delStorage('screenStrDate');
        this.ifScreen = false;
      }
      else{
        this.infoStorage('screenStr',arr.join('_'));
        var today = this.getDateObj('');
        this.infoStorage('screenStrDate',today.YYYY + '-' + today.MM + '-' + today.DD);
        this.ifScreen = true;
      }
      this.closeScreen(); 

      var _this = this; 
      setTimeout(this.listMatch,10);
    },
    cancelScreen(){//取消筛选
      var list = this.league;
      for(var i = 0; i < this.league.length;i++){
        if(this.league[i].change){
          var obj = this.league[i];
          obj.change = !obj.change;
          obj.on = !obj.on;
          this.$set(this.league,i,obj);
        }
      }
      this.closeScreen();
    },
    toggleLeague(index){//联赛按钮点击
      var lastIndex = 0;
      var count = 0;
      for(var i = 0;i < this.league.length;i++){
        if(this.league[i].on){
          lastIndex = i;
          count++;
        }
      }
      if(count == 1 && index == lastIndex){
        this.alertTip = this.txtLang[this.curLang]['screenError'];
        this.$refs.Alert.show();
        return;
      }

      var obj = this.league[index];
      obj.on = !obj.on;
      obj.change = !obj.change;
      this.$set(this.league,index,obj);
    },
    allScreenLeague(){//初始化没筛选时=全选处理
      for(var i = 0; i < this.league.length;i++){
        var obj = this.league[i];
        obj.on = true;
        obj.change = false;
        this.$set(this.league,i,obj); 
      }
    },
    listLeague(){//初始化联赛
      var dateObj;
      if(this.navIndex1 == 0){
        //dateObj = this.getDateObj('2020-01-14');
        dateObj = this.getDateObj('');
      }
      else if(this.navIndex1 == 1){
        var obj = this.futureDate[this.futureIndex];
        dateObj = this.getDateObj(obj.y + '/' + obj.m + '/' + obj.d);
      }
      this.axios.get(this.getHost() + '/games/competition-list?lan=' + this.langIndex + '&start=' + dateObj.start + '&end=' + dateObj.end).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            //读取联赛列表数据，默认全不选
            var arr = [];
            for(var i = 0; i < re.data.list.length;i++){
              arr.push(re.data.list[i]);
              arr[arr.length - 1]['on'] = false;
              arr[arr.length - 1]['change'] = false; 
            }
            this.league = arr;

            //有联赛=有比赛
            if(this.league.length != 0){
              //有筛选
              if(localStorage.getItem('screenStr') != null){
                //筛选过的联赛选中
                var screenArr = localStorage.getItem('screenStr').split('_');
                for(var i = 0;i < screenArr.length;i++){
                  for(var j = 0;j < this.league.length;j++){
                    if(screenArr[i] == this.league[j].id){
                      var obj = this.league[j];
                      obj.on = true;
                      obj.change = false;
                      this.$set(this.league,j,obj);
                    }
                  }
                }
                this.ifScreen = true;
                //此处有坑，有可能筛选的联赛刚好变成全选
              }
              //无筛选
              else{
                this.allScreenLeague();
                this.ifScreen = false;
              }
              this.listMatch();
            }
            else{
              this.ifScreen = false;
              this.popSH5 = false;
            }
          }
          else if(re.code == 401){
            this.toLogin();
            this.popSH5 = false;
          }
          else{
            alert(re.message);
            this.popSH5 = false;
          }
      }).catch((response)=>{
        //console.log(response);
      });
    },
    //联赛-未来
    closeScreen2(){//关闭联赛筛选

      this.screenHide2 = true;
    },
    allScreen2(){//全选
      this.screenType2 = 0;
      for(var i = 0;i < this.league2.length;i++){
        if(!this.league2[i].on){
          var obj = this.league2[i];
          obj.on = true;
          obj.change = !obj.change;
          this.$set(this.league2,i,obj);
        }
      }
    },
    contractScreen2(){//反选
      this.screenType2 = 1;
      for(var i = 0;i < this.league2.length;i++){
        var obj = this.league2[i];
        obj.on = !obj.on;
        obj.change = !obj.change;
        this.$set(this.league2,i,obj);
      }
    },
    confirmScreen2(){//确定筛选
      var count = 0;
      for(var i = 0;i < this.league2.length;i++){
        if(this.league2[i].on){
          count ++;
        }
      }
      if(count == 0){
        this.alertTip = this.txtLang[this.curLang]['screenError'];
        this.$refs.Alert.show();
        return;
      }

      var arr = [];
      var count2 = 0;
      for(var i = 0;i < this.league2.length;i++){
        var obj = this.league2[i];
        if(this.league2[i].on){
          arr.push(obj.id);
          count2 ++;
        }
        obj.change = false;
        this.$set(this.league2,i,obj);
      }

      //全选=未筛选
      if(count2 == this.league2.length){
        this.delStorage('screenStr2');
        this.delStorage('screenStrDate2');
        this.ifScreen2 = false;
      }
      else{
        this.infoStorage('screenStr2',arr.join('_'));
        var today = this.getDateObj('');
        this.infoStorage('screenStrDate2',today.YYYY + '-' + today.MM + '-' + today.DD);
        this.ifScreen2 = true;
      }
      this.closeScreen2(); 
      setTimeout(this.listMatch2,10);
    },
    cancelScreen2(){//取消筛选
      var list = this.league2;
      for(var i = 0; i < this.league2.length;i++){
        if(this.league2[i].change){
          var obj = this.league2[i];
          obj.change = !obj.change;
          obj.on = !obj.on;
          this.$set(this.league2,i,obj);
        }
      }
      this.closeScreen2();
    },
    toggleLeague2(index){//联赛按钮点击
      var lastIndex = 0;
      var count = 0;
      for(var i = 0;i < this.league2.length;i++){
        if(this.league2[i].on){
          lastIndex = i;
          count++;
        }
      }
      if(count == 1 && index == lastIndex){
        this.alertTip = this.txtLang[this.curLang]['screenError'];
        this.$refs.Alert.show();
        return;
      }

      var obj = this.league2[index];
      obj.on = !obj.on;
      obj.change = !obj.change;
      this.$set(this.league2,index,obj);
    },
    allScreenLeague2(){//初始化没筛选时=全选处理
      for(var i = 0; i < this.league2.length;i++){
        var obj = this.league2[i];
        obj.on = true;
        obj.change = false;
        this.$set(this.league2,i,obj); 
      }
    },
    listLeague2(){//初始化联赛
      var obj = this.futureDate[this.futureIndex];
      var  dateObj = this.getDateObj(obj.y + '/' + obj.m + '/' + obj.d);
      this.axios.get(this.getHost() + '/games/competition-list?lan=' + this.langIndex + '&start=' + dateObj.start + '&end=' + dateObj.end).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            //读取联赛列表数据，默认全不选
            var arr = [];
            for(var i = 0; i < re.data.list.length;i++){
              arr.push(re.data.list[i]);
              arr[arr.length - 1]['on'] = false;
              arr[arr.length - 1]['change'] = false; 
            }
            this.league2 = arr;

            //有联赛=有比赛
            if(this.league2.length != 0){
              //有筛选
              if(localStorage.getItem('screenStr2') != null){
                //筛选过的联赛选中
                var screenArr = localStorage.getItem('screenStr2').split('_');
                for(var i = 0;i < screenArr.length;i++){
                  for(var j = 0;j < this.league2.length;j++){
                    if(screenArr[i] == this.league2[j].id){
                      var obj = this.league2[j];
                      obj.on = true;
                      obj.change = false;
                      this.$set(this.league2,j,obj);
                    }
                  }
                }
                this.ifScreen2 = true;
                //此处有坑，有可能筛选的联赛刚好变成全选
              }
              //无筛选
              else{
                this.allScreenLeague2();
                this.ifScreen2 = false;
              }
              this.listMatch2();
            }
            else{
              this.ifScreen2 = false;
              this.popSH5 = false;
            }
          }
          else if(re.code == 401){
            this.popSH5 = false;
            this.toLogin();
          }
          else{
            this.popSH5 = false;
            alert(re.message);
          }
      }).catch((response)=>{
        //console.log(response);
      });
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //比赛
    listMatch(){//读取今日比赛列表
      var dateObj = this.getDateObj('');
      //var dateObj = this.getDateObj('2020-01-14');
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      var idArr = [];
      for(var i = 0;i < this.league.length;i++){
        if(this.league[i].on){
          idArr.push(this.league[i].id);
        }
      }
      var screenStr = idArr.join('_');
      //今日-热门
      if(this.navIndex2 == 0){
        this.axios.get(this.getHost() + '/games/list/hot?lan=' + this.langIndex + '&start=' + dateObj.start + '&end=' + dateObj.end + '&competition=' + screenStr + token).then(
          (response)=>{
          var re = response.data;
          this.popSH5 = false;
          if(re.code == 200){
            var list = re.data.competition_list;
            var obj = {};
            var obj2 = {};
            for(var i = 0;i < list.length;i++){
              if(i == 0)
                list[i]['all'] = true;
              else
                list[i]['all'] = false;
              var game = list[i].game_list;
              for(var ii = 0;ii < game.length;ii++){
                var game_obj = {};
                var game_obj2 = {};
                var obj_play_type = game[ii].play_type;
                for(var iii = 0;iii < obj_play_type.length;iii++){
                  game_obj[obj_play_type[iii].id] = {};
                  game_obj2[obj_play_type[iii].id] = {};

                  game_obj[obj_play_type[iii].id]['select_0'] = false;
                  game_obj[obj_play_type[iii].id]['select_1'] = false;
                  if(obj_play_type[iii].id == 1){
                    game_obj[obj_play_type[iii].id]['select_2'] = false;
                  }

                  game_obj2[obj_play_type[iii].id]['seal_status'] = obj_play_type[iii].seal_status;
                  game_obj2[obj_play_type[iii].id]['isbet_0'] = obj_play_type[iii].option[0].is_bet;
                  game_obj2[obj_play_type[iii].id]['isbet_1'] = obj_play_type[iii].option[1].is_bet;
                  game_obj2[obj_play_type[iii].id]['odds_0'] = obj_play_type[iii].option[0].odds;
                  game_obj2[obj_play_type[iii].id]['odds_1'] = obj_play_type[iii].option[1].odds;
                  game_obj2[obj_play_type[iii].id]['oddsChange_0'] = 0;
                  game_obj2[obj_play_type[iii].id]['oddsChange_1'] = 0;
                  if(obj_play_type[iii].id == 1){
                    game_obj2[obj_play_type[iii].id]['isbet_2'] = obj_play_type[iii].option[2].is_bet;
                    game_obj2[obj_play_type[iii].id]['odds_2'] = obj_play_type[iii].option[2].odds;
                    game_obj2[obj_play_type[iii].id]['oddsChange_2'] = 0;
                  }
                }
                obj[game[ii].id] = game_obj;
                obj2[game[ii].id] = game_obj2;
              }

            }
            this.listHot = list;
            this.listHotDeal = obj;
            this.listHotOther = obj2;
            setTimeout(this.initCar,10);
            //console.log(obj2);
          }
          else if(re.code == 401){
            this.toLogin();
          }
          else{
            alert(re.message);
          }
        }).catch((response)=>{
          //console.log(response);
        });
      }
      //今日-最新
      else if(this.navIndex2 == 1){
        this.axios.get(this.getHost() + '/games/list/new?lan=' + this.langIndex + '&start=' + dateObj.start + '&end=' + dateObj.end + '&competition=' + screenStr + token).then(
          (response)=>{
          var re = response.data;
          this.popSH5 = false;
          if(re.code == 200){
            this.listNew = re.data.game_list;
          }
          else if(re.code == 401){
            this.toLogin();
          }
          else{
            alert(re.message);
          }
        }).catch((response)=>{
          //console.log(response);
        });
      }
    }, 
    listMatch2(){//读取未来比赛列表
      var obj = this.futureDate[this.futureIndex];
      var dateObj = this.getDateObj(obj.y + '/' + obj.m + '/' + obj.d);
      
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      var idArr = [];
      for(var i = 0;i < this.league2.length;i++){
        if(this.league2[i].on){
          idArr.push(this.league2[i].id);
        }
      }
      var screenStr = idArr.join('_');
      this.axios.get(this.getHost() + '/games/list/hot?lan=' + this.langIndex + '&start=' + dateObj.start + '&end=' + dateObj.end + '&competition=' + screenStr + token).then(
        (response)=>{
        var re = response.data;
        if(re.code == 200){
          this.popSH5 = false;
          var list = re.data.competition_list;
          var obj = {};
          var obj2 = {};
          for(var i = 0;i < list.length;i++){
            if(i == 0)
              list[i]['all'] = true;
            else
              list[i]['all'] = false;
            var game = list[i].game_list;
            for(var ii = 0;ii < game.length;ii++){
              var game_obj = {};
              var game_obj2 = {};
              var obj_play_type = game[ii].play_type;
              for(var iii = 0;iii < obj_play_type.length;iii++){
                game_obj[obj_play_type[iii].id] = {};
                game_obj2[obj_play_type[iii].id] = {};

                game_obj[obj_play_type[iii].id]['select_0'] = false;
                game_obj[obj_play_type[iii].id]['select_1'] = false;
                if(obj_play_type[iii].id == 1){
                  game_obj[obj_play_type[iii].id]['select_2'] = false;
                }

                game_obj2[obj_play_type[iii].id]['seal_status'] = obj_play_type[iii].seal_status;
                game_obj2[obj_play_type[iii].id]['isbet_0'] = obj_play_type[iii].option[0].is_bet;
                game_obj2[obj_play_type[iii].id]['isbet_1'] = obj_play_type[iii].option[1].is_bet;
                game_obj2[obj_play_type[iii].id]['odds_0'] = obj_play_type[iii].option[0].odds;
                game_obj2[obj_play_type[iii].id]['odds_1'] = obj_play_type[iii].option[1].odds;
                game_obj2[obj_play_type[iii].id]['oddsChange_0'] = 0;
                game_obj2[obj_play_type[iii].id]['oddsChange_1'] = 0;
                if(obj_play_type[iii].id == 1){
                  game_obj2[obj_play_type[iii].id]['isbet_2'] = obj_play_type[iii].option[2].is_bet;
                  game_obj2[obj_play_type[iii].id]['odds_2'] = obj_play_type[iii].option[2].odds;
                  game_obj2[obj_play_type[iii].id]['oddsChange_2'] = 0;
                }
              }
              obj[game[ii].id] = game_obj;
              obj2[game[ii].id] = game_obj2;
            }

          }
          this.listFuture = list;
          this.listFutureDeal = obj;
          this.listFutureOther = obj2;
          setTimeout(this.initCar,10);
        }
        else if(re.code == 401){
          this.toLogin();
        }
        else{
          alert(re.message);
        }
      }).catch((response)=>{
        //console.log(response);
      });
    },    
  	listSH(index){//展开收缩
      var obj = this.listHot[index];
      obj.all = !obj.all;
      this.$set(this.listHot,index,obj);
    },
    listSH2(index){//展开收缩
      var obj = this.listFuture[index];
      obj.all = !obj.all;
      this.$set(this.listFuture,index,obj);
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //tab切换
    tabDate(index){//切换未来日期
      this.futureIndex = index;
      this.refreshMonth();
    },
    refreshMonth(){//更新当前月份
      var obj = this.futureDate[this.futureIndex];
      this.curMonth = obj.m + "<br/>" + this.monthName[obj.m];
      this.popSH5 = true;
      this.listLeague2();
    },
    transformDay(index){//时区转换
      var dateObj = this.futureDate[index];
      var dateStr = dateObj.y + '/' + dateObj.m + '/' + dateObj.d;
      var nowDate = new Date();
      dateStr += ' ' + nowDate.getHours() + ':' + nowDate.getMinutes() + ':' + nowDate.getDate();
      
      function getDateByDateStr(dateStr, timeZone, format){
          var date_sl = dateStr.split(",");
          var dtm = '';
          if(date_sl.length<6) date_sl[5]='00';
          if(timeZone=="+0800"){
              dtm =  new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3]), Number(date_sl[4]), Number(date_sl[5]), 0);
          }
          else{
              var TZ_Hour = parseFloat(timeZone.substring(0, 3));
              var TZ_Minute = parseFloat(timeZone.substring(3, 5));
              var tz_mintue_diff2 = TZ_Minute;
              var tz_hour_diff2;
              if (TZ_Hour < 0){
                  tz_hour_diff2 = 0 - (8 - TZ_Hour);
                  tz_mintue_diff2 = 0 - tz_mintue_diff2;
              }else{
                  tz_hour_diff2 = TZ_Hour - 8;
              }
              dtm =   new Date(Number(date_sl[0]), Number(date_sl[1]) - 1, Number(date_sl[2]), Number(date_sl[3])+tz_hour_diff2, Number(date_sl[4])+tz_mintue_diff2, Number(date_sl[5]), 0);
          }
          var dateFormat = format;
          dateFormat = dateFormat.replace('YYYY',dtm.getFullYear());
          dateFormat = dateFormat.replace('YY',String(dtm.getFullYear()).substring(2));
          dateFormat = dateFormat.replace('MM',dtm.getMonth()<9?("0" +(dtm.getMonth()+1)):(dtm.getMonth()+1));
          dateFormat = dateFormat.replace('dd',dtm.getDate()<10?("0" +dtm.getDate()):dtm.getDate());
          dateFormat = dateFormat.replace('HH',dtm.getHours()<10?("0" +dtm.getHours()):dtm.getHours());
          dateFormat = dateFormat.replace('mm',dtm.getMinutes()<10?("0" +dtm.getMinutes()):dtm.getMinutes());
          dateFormat = dateFormat.replace('ss',dtm.getSeconds()<10?("0" +dtm.getSeconds()):dtm.getSeconds());
          return dateFormat;
      }

      return getDateByDateStr(dateStr.replace(/\D/g, ','),this.timezone,'dd');
    },
    setFuture(){//设置未来6天
      var today = new Date();
      var arr =  [];
      for(var i = 0;i < 6;i++){
        var obj = new Date(today);
        obj.setDate(today.getDate() + (i + 1));
        arr.push({y:obj.getFullYear(),m:obj.getMonth() + 1,d:obj.getDate()});
      }
      this.futureDate = arr;
      this.refreshMonth();
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    tab1(index){//今日未来切换
      var s = document.documentElement.scrollTop || document.body.scrollTop;
      if(index == 0){
        this.position2 = s;
      }
      else{
        this.position = s;
      }
      this.navIndex1 = index;
      var _this = this;
      setTimeout(function(){
        document.documentElement.scrollTop = index == 0 ? _this.position : _this.position2;
      },10);
    },
    tab2(index){//热门最新切换
      this.navIndex2 = index;
      this.popSH5 = true;
      setTimeout(this.listMatch,10);
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //购物车
    addCar(listType,matchId,playTypeId,optionIndex,optionId,odds,hname,aname,handicap,bet_status,seal_status){//选择投注项
      //封盘状态判断
      if(seal_status != 1){
        return;
      }
      var noSeal = true;
      var matchHot = this.listHotOther[matchId];
      if(typeof matchHot != 'undefined'){
        var playTypeItem = matchHot[playTypeId];
        if(playTypeItem['seal_status'] != 1){
          noSeal = false;
        }
      }
      var matchFuture = this.listFutureOther[matchId];
      if(typeof matchFuture != 'undefined'){
        var playTypeItem = matchFuture[playTypeId];
        if(playTypeItem['seal_status'] != 1){
          noSeal = false;
        }
      }
      if(!noSeal){
        return;
      }

      //封号状态判断
      if(this.canBet != 1){
        this.alertTip = this.txtLang[this.curLang]['sealAccout'];
        this.$refs.Alert.show();
        return;
      }

      //已投注判断
      if(bet_status != 1){
        this.alertTip = this.txtLang[this.curLang]['hasBet'];
        this.$refs.Alert.show();
        return;
      }
      var canBet = true;
      var matchHot = this.listHotOther[matchId];
      if(typeof matchHot != 'undefined'){
        var playTypeItem = matchHot[playTypeId];
        if(playTypeItem['isbet_0'] != 1 || playTypeItem['isbet_1'] != 1){
          canBet = false;
        }
        if(typeof playTypeItem['isbet_2'] != 'undefined' && playTypeItem['isbet_2'] != 1)
          canBet = false;
      }
      var matchFuture = this.listFutureOther[matchId];
      if(typeof matchFuture != 'undefined'){
        var playTypeItem = matchFuture[playTypeId];
        if(playTypeItem['isbet_0'] != 1 || playTypeItem['isbet_1'] != 1){
          canBet = false;
        }
        if(typeof playTypeItem['isbet_2'] != 'undefined' && playTypeItem['isbet_2'] != 1)
          canBet = false;
      }
      if(!canBet){
        this.alertTip = this.txtLang[this.curLang]['hasBet'];
        this.$refs.Alert.show();
        return;
      }


      var listHotDeal = listType == 1 ? this.listHotDeal : this.listFutureDeal ;
      var playType = listHotDeal[matchId][playTypeId];


      //二次点击同个投注项
      if(playType['select_' + optionIndex] == true){
        playType['select_' + optionIndex] = false;
      }
      //判断是否同个玩法切换投注项
      else{
        var hasBet = false;

        for(var v in playType){
          if(playType[v])
            hasBet = true;
          playType[v] = false;
        }
        //同个玩法切换
        if(hasBet){
          playType['select_' + optionIndex] = true;  
          // this.alertTip = this.txtLang[this.curLang]['oneBet'];
          // this.$refs.Alert.show();
        }   
        //其他比赛需判断是否超过最大投注数
        else{
          //超过最大投注数
          if(this.carArr.length >= this.bet_order_max){
            this.alertTip = this.txtLang[this.curLang]['overBetMax'].replace(/{value}/g,this.bet_order_max);
            this.$refs.Alert.show();
            return;
          }
          else{
            playType['select_' + optionIndex] = true;  
          }
        }
      }

      var shopcar = localStorage.getItem('shopcar');
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }

      var carIndex = 0;
      //遍历是否已存在该投注
      for(carIndex = 0; carIndex < shopcar.length;carIndex++){
        if(shopcar[carIndex].matchId == matchId && shopcar[carIndex].playTypeId == playTypeId && shopcar[carIndex].optionId == optionId)
          break;
      }

      var lastShopcar = [];
      if(carIndex == shopcar.length){
        //不存在，加入购物车
        //先遍历是否有相同玩法的投注，有则删除
        for(var i = 0;i < shopcar.length;i++){
          if(!(shopcar[i].matchId == matchId && shopcar[i].playTypeId == playTypeId && shopcar[i].optionId != optionId)){
            lastShopcar.push(shopcar[i]);
          }
        }
        var carObj = {
          matchId:matchId,
          playTypeId:playTypeId,
          optionId:optionId,
          optionIndex:optionIndex,
          odds:odds,
          oddsChange:0,
          hname:hname,
          aname:aname,
          handicap:handicap,
          coin:this.bet_min,
          errorTxt:'',
          listType:listType
        };
        lastShopcar.push(carObj);
      }
      else{
        //存在，删除投注
        for(var i = 0;i < shopcar.length;i++){
          if(i != carIndex){
            lastShopcar.push(shopcar[i]);
          }
        }
      }

      //console.log(lastShopcar);
      this.infoStorage('shopcar',JSON.stringify(lastShopcar));
      this.carArr = lastShopcar;
      this.calCarTotal();
      // var optionName = this.txtLang[this.curLang]['playOption'][playTypeId][optionIndex];
      // console.log(optionName);
      // console.log(odds);
      // var playTypeName = this.txtLang[this.curLang]['playType'][playTypeId];
      // console.log(playTypeName);
      // console.log(hname);
      // console.log(aname);
    },
    initCar(){//初始化购物车
      var shopcar = localStorage.getItem('shopcar');
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }

      // var arr = [];
      // for(var i = 0;i < shopcar.length;i++){
      //   if(shopcar[i].listType == 1){
      //     for(var k in this.listHotDeal){
      //       if(shopcar[i].matchId == k){
      //         arr.push(shopcar[i]);
      //         break;
      //       }
      //     }
      //   } 
      // }
      // for(var i = 0;i < shopcar.length;i++){
      //   if(shopcar[i].listType == 2){
      //     arr.push(shopcar[i]);
      //   }
      // }

      var arr = shopcar;
      //console.log(arr);

      for(var i = 0;i < arr.length;i++){
        if(typeof this.listHotDeal[arr[i].matchId] != 'undefined'){
          var playType = this.listHotDeal[arr[i].matchId][arr[i].playTypeId];
          playType['select_' + arr[i].optionIndex] = true;
        }
          
      }

      for(var i = 0;i < arr.length;i++){
        if(typeof this.listFutureDeal[arr[i].matchId] != 'undefined'){
          var playType = this.listFutureDeal[arr[i].matchId][arr[i].playTypeId];
          playType['select_' + arr[i].optionIndex] = true;
        }
      }
      this.carArr = arr;
      this.infoStorage('shopcar',JSON.stringify(arr));
      this.calCarTotal();

    },  
    openCar(){//打开购物车

      this.carHide = false;
    },
    closeCar(){//关闭购物车

      this.carHide = true;
    },
    calCarTotal(){//计算购物车总数
      var shopcar = localStorage.getItem('shopcar');
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }
      var totalBet = 0,totalBack = 0;
      for(var i = 0;i < shopcar.length;i++){
        totalBet += shopcar[i].coin;
        totalBack += this.calBack(shopcar[i].playTypeId,shopcar[i].coin,shopcar[i].odds);
      }
      this.carTotalBet = totalBet;
      this.carTotalBack = totalBack;
    },
    getErrorTip(type,type2,value,value2){//获取错误提示,type-错误类型，type2-错误显示类型
      if(type2 == 'text')
        return this.txtLang[this.curLang].errorTip[type].replace(/{value}/g,value);
      else if(type2 == 'window')
        return this.txtLang[this.curLang].errorTip[type].replace(/{value}/g,'<span>' + value + '</span>');
    },
    refreshCar(arr){//更新购物车
      var sign = false;
      var shopcar = localStorage.getItem('shopcar');
      var shopcarSuccess = [];
      var shopcarError = [];
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }
      
      if(arr.length == 0){
        //console.log('全部提交成功');
        this.clearSuccessBet(shopcar);
        this.refreshErrorCar([]);
        this.popSH3 = true;
      }
      else{
        for(var i = 0;i < shopcar.length;i++){
          if(!arr.hasOwnProperty(i)){
            shopcarSuccess.push(shopcar[i]);
          }
          else{
            shopcarError.push(shopcar[i]);
          }
        }

        //投注成功处理
        if(shopcarSuccess.length > 0){
          this.clearSuccessBet(shopcarSuccess);
        }
        //投注失败处理
        this.refreshErrorCar(shopcarError);
        var curIndex = -1;
        for(var i in arr){
            var obj = arr[i];
            curIndex ++;
            // console.log(obj.type);
            // console.log(obj.tips_type);
            if(obj.tips_type == 'window'){
              if(sign)continue;
              //弹窗提示
              this.popErrorTxt = this.getErrorTip(obj.type,obj.tips_type,obj.value);
              var btnObj = {
                6:this.txtLang[this.curLang]['cancel'],
                8:this.txtLang[this.curLang]['know'],
                9:this.txtLang[this.curLang]['close']
              }
              this.popErrorBtnTxt = btnObj[obj.type];
              this.popSH = true;
              
              //调用弹窗
              sign = true;
            }
            else if(obj.tips_type == 'text'){
              //投注窗提示
              var carArr = this.carArr;
              // console.log(carArr);
              // console.log(i);
              carArr[curIndex].errorTxt = this.getErrorTip(obj.type,obj.tips_type,obj.value);
              carArr[curIndex].errorType = obj.type;
              if(obj.type == 7 || obj.type == 15){
                var newOdds = obj.odds;
                var oldOdds = carArr[curIndex].odds; 
                carArr[curIndex].odds = newOdds;
                carArr[curIndex].oddsChange = parseFloat(newOdds) - parseFloat(oldOdds);
                // setTimeout(function(){
                //   carArr[j].odds
                // },3000);
                this.infoStorage('shopcar',JSON.stringify(carArr));
              }
            }
        }   
        
      }
      this.calCarTotal();
    },
    refreshErrorCar(arr){//更新购物车为投注失败的列表
      this.carArr = arr;
      if(arr.length == 0){
        this.carHide = true;
      }
      this.infoStorage('shopcar',JSON.stringify(arr));
    },
    clearSuccessBet(shopcar){//投注成功并删除
      var listDeal = {};
      var listDealOther = {};
      for(var v in this.listHotDeal){
        listDeal[v] = this.listHotDeal[v];
        listDealOther[v] = this.listHotOther[v];
      }
      for(var v in this.listFutureDeal){
        listDeal[v] = this.listFutureDeal[v];
        listDealOther[v] = this.listFutureOther[v];
      }

      for(var i = 0;i < shopcar.length;i++){
        var match = listDeal[shopcar[i].matchId];
        if(typeof(match) != 'undefined'){
            //删除列表中选中的标识
            var playType = match[shopcar[i].playTypeId];
            playType['select_' + shopcar[i].optionIndex] = false;
            //添加列表已投标识
            var betType = listDealOther[shopcar[i].matchId][shopcar[i].playTypeId];
            betType['isbet_' + shopcar[i].optionIndex] = 2;  
        } 
      }
    },
    delCarBet(index){//删除购物车投注
      var shopcar = localStorage.getItem('shopcar');
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }


      var listDeal = {};
      var listDealOther = {};
      for(var v in this.listHotDeal){
        listDeal[v] = this.listHotDeal[v];
        listDealOther[v] = this.listHotOther[v];
      }
      for(var v in this.listFutureDeal){
        listDeal[v] = this.listFutureDeal[v];
        listDealOther[v] = this.listFutureOther[v];
      }

      var match = listDeal[shopcar[index].matchId];
      if(typeof(match) != 'undefined'){
          var playType = match[shopcar[index].playTypeId];
          playType['select_' + shopcar[index].optionIndex] = false;
      }

      var arr = [];
      for(var i = 0;i < shopcar.length;i++){
        if(i != index){
          arr.push(shopcar[i]);
        }
      }
      this.carArr = arr;
      if(arr.length == 0)
        this.carHide = true;
      this.infoStorage('shopcar',JSON.stringify(arr));
      this.calCarTotal();
    },
    toBet(){//提交投注
      var _this = this;
      var shopcar = localStorage.getItem('shopcar');
      if(shopcar == null){
        shopcar = [];
      }
      else{
        shopcar = JSON.parse(shopcar);
      }

      // console.log(shopcar);
      // return;

      var arr = [];
      for(var i = 0;i < shopcar.length;i++){
        arr.push({
          game_id:shopcar[i].matchId,
          play_id:shopcar[i].playTypeId,
          option_id:shopcar[i].optionId,
          odds:shopcar[i].odds,
          coin:shopcar[i].coin,
          handicap:shopcar[i].handicap
        });
      }

      _this.popSH4 = true;

      //console.log(arr);
      this.axios.post(this.getHost() + '/games/bet',qs.stringify({
            token: localStorage.getItem('guess_token'),
            data:JSON.stringify(arr),
            lan:this.langIndex
        })
      ).then(
          (response)=>{
              var re = response.data;
               _this.popSH4 = false;
              if(re.code == 200){
                  _this.refreshCar(re.data);
                  _this.refreshInfo();
              }
              else if(re.code == 401){
                this.gotoLogin();
              }
              else{
                 _this.popSH2 = true;
              }
          }).catch((response)=>{
          console.log(response);
          _this.popSH4 = false;
          _this.popSH2 = true;
      });
    },
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //其他
    checkStorage(){//筛选缓隔日存处理
      if(localStorage.getItem('screenStr') != null){
        var StorageDate = localStorage.getItem('screenStr');
        var today = this.getDateObj('');
        if(localStorage.getItem('screenStrDate') != today.YYYY + '-' + today.MM + '-' + today.DD){
          this.delStorage('screenStr');
          this.delStorage('screenStrDate');
          this.delStorage('screenStr2');
          this.delStorage('screenStrDate2');
        }
      }
    },
    scrollFn() {//滚动收缩处理
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop;
      
      var curScroll = this.scroll;
      var reductPart = this.$refs.lx.offsetHeight;
      if(reductPart > this.lxHeight)
        this.lxHeight = reductPart;

       // console.log(curScroll);
       // console.log(this.lxHeight / 3 * 2);

      if(curScroll > this.lxHeight / 3 * 2){
        this.lxHide = true;
      }
      else {
        this.lxHide = false;
      }
    },
    hideSide(){//侧边栏隐藏

      this.$refs.Model.hideSide()
    },
    refreshInfo(){//更新个人信息
      var _this = this;
      this.getUserInfo({
        success:function(e){
          //console.log(e.data.data);
          _this.curCoin = e.data.data.coins;
          _this.canBet = e.data.data.status;
          _this.noticeNum = e.data.data.notice_num;
        }
      });
    },
    getBetSetting(){//获取竞猜配置
      this.axios.get(this.getHost() + '/games/config?lan=' + this.langIndex).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            this.bet_min = re.data.bet_min;
            this.bet_max = re.data.bet_max;
            this.bet_order_max = re.data.bet_order_max;
          }
          else if(re.code == 401){
            this.toLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        //console.log(response);
      });
    },
    loadLx(){//读取轮显
      this.axios.get(this.getHost() + '/banner/list?lan=' + this.langIndex).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            var arr = [];
            for(var i = 0;i < re.data.length && i < this.lxMax;i++){
              arr.push(re.data[i]);
              this.lx.push(re.data[i]);
            }
            //this.lx = arr;
          }
          else if(re.code == 401){
            this.toLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        //console.log(response);
      });
    },
    initWebSocket(){ //初始化weosocket
      var protocol = location.protocol.indexOf('https') > -1 ? 'wss://' : 'ws://';
      const wsuri = protocol + "websocket" + this.getHostName() + ".7msport.com/oversea-guess/";
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;        
      this.websock.onopen = this.websocketonopen;        
      this.websock.onerror = this.websocketonerror;        
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen(){ //连接建立之后执行send方法发送数据
      let actions = {
      };        
      //this.websocketsend(JSON.stringify(actions));

      var that = this;
      that.websocketsend('ping');
      this.socketSt = setInterval(function(){
        that.websocketsend('ping');
      },5000);
    },
    websocketonerror(){//连接建立失败重连
      console.log('触发onerror');
      clearInterval(this.socketSt); 
      this.socketErrorCount ++;
      if(this.socketErrorCount <= 10)
        this.initWebSocket();
    },
    websocketonmessage(e){ //数据接收
      if(e.data == 'pong'){
        return;
      }

      const list = JSON.parse(e.data);
      //console.log('socket数据:');
      //console.log(list);
      
      var listHot = this.listHotOther;
      var listFuture = this.listFutureOther;

      var _this = this;

      for(var v in list){
        if(typeof listHot[v] != 'undefined'){
          var reMatch = list[v];
          for(var vv in reMatch){
             var odds0 = reMatch[vv][1];
             var odds1 = reMatch[vv][2];
             var old_odds0 = listHot[v][vv]['odds_0'];
             var old_odds1 = listHot[v][vv]['odds_1'];
             listHot[v][vv]['seal_status'] = reMatch[vv]['seal_status'];
             listHot[v][vv]['odds_0'] = parseFloat(odds0);
             listHot[v][vv]['odds_1'] = parseFloat(odds1);
             listHot[v][vv]['oddsChange_0'] = parseFloat(odds0) - parseFloat(old_odds0);
             listHot[v][vv]['oddsChange_1'] = parseFloat(odds1) - parseFloat(old_odds1);
             if(listHot[v][vv]['oddsChange_0'] != 0){
                (function(matchId,playTypeId) {
                    setTimeout( function(){
                        _this.listHotOther[matchId][playTypeId]['oddsChange_0'] = 0;
                    }, 3000 );
                })(v,vv);
             }
             if(listHot[v][vv]['oddsChange_1'] != 0){
                //setTimeout("this.listHotOther[" + v + "][" + vv + "]['oddsChange_1'] = 0;",3000);
                (function(matchId,playTypeId) {
                    setTimeout( function(){
                        _this.listHotOther[matchId][playTypeId]['oddsChange_1'] = 0;
                    }, 3000 );
                })(v,vv);
             }
             if(typeof reMatch[vv][3] != 'undefined'){
              var odds2 = reMatch[vv][3];
              var old_odds2 = listHot[v][vv]['odds_2'];
              listHot[v][vv]['odds_2'] = parseFloat(odds2);
              listHot[v][vv]['oddsChange_2'] = parseFloat(odds2) - parseFloat(old_odds2);
              if(listHot[v][vv]['oddsChange_2'] != 0){
                  (function(matchId,playTypeId) {
                      setTimeout( function(){
                          _this.listHotOther[matchId][playTypeId]['oddsChange_2'] = 0;
                      }, 3000 );
                  })(v,vv);
               }
             }
          }
        }
        if(typeof listFuture[v] != 'undefined'){
          var reMatch = list[v];
          for(var vv in reMatch){
             var odds0 = reMatch[vv][1];
             var odds1 = reMatch[vv][2];
             var old_odds0 = listFuture[v][vv]['odds_0'];
             var old_odds1 = listFuture[v][vv]['odds_1'];
             listFuture[v][vv]['seal_status'] = reMatch[vv]['seal_status'];
             listFuture[v][vv]['odds_0'] = parseFloat(odds0);
             listFuture[v][vv]['odds_1'] = parseFloat(odds1);
             listFuture[v][vv]['oddsChange_0'] = parseFloat(odds0) - parseFloat(old_odds0);
             listFuture[v][vv]['oddsChange_1'] = parseFloat(odds1) - parseFloat(old_odds1);
             if(listFuture[v][vv]['oddsChange_0'] != 0){
                (function(matchId,playTypeId) {
                    setTimeout( function(){
                        _this.listFutureOther[matchId][playTypeId]['oddsChange_0'] = 0;
                    }, 3000 );
                })(v,vv);
             }
             if(listFuture[v][vv]['oddsChange_1'] != 0){
                //setTimeout("this.listHotOther[" + v + "][" + vv + "]['oddsChange_1'] = 0;",3000);
                (function(matchId,playTypeId) {
                    setTimeout( function(){
                        _this.listFutureOther[matchId][playTypeId]['oddsChange_1'] = 0;
                    }, 3000 );
                })(v,vv);
             }
             if(typeof reMatch[vv][3] != 'undefined'){
              var odds2 = reMatch[vv][3];
              var old_odds2 = listFuture[v][vv]['odds_2'];
              listFuture[v][vv]['odds_2'] = parseFloat(odds2);
              listFuture[v][vv]['oddsChange_2'] = parseFloat(odds2) - parseFloat(old_odds2);
              if(listFuture[v][vv]['oddsChange_2'] != 0){
                  (function(matchId,playTypeId) {
                      setTimeout( function(){
                          _this.listFutureOther[matchId][playTypeId]['oddsChange_2'] = 0;
                      }, 3000 );
                  })(v,vv);
               }
             }
          }
        }
      }
    },
    websocketsend(Data){//数据发送
      this.websock.send(Data);
    },
    websocketclose(e){  //关闭
      console.log('触发onclose',e);
      clearInterval(this.socketSt); 
      this.socketErrorCount ++;
      if(this.socketErrorCount <= 10)
        this.initWebSocket();
    },
    closeGuide(){//关闭引导1
      this.guideSH = false;
      this.infoStorage('firstLogin',1);
    },
    closeGuide2(){//关闭引导2
      this.guideSH2 = false;
    },
    checkNoLoginGuide(){//检查是否第一次未登录
      if(localStorage.getItem('firstNoLogin') == null){
        this.axios.get(this.getHost() + '/index-info?lan=' + this.langIndex).then(
            (response)=>{
            var re = response.data;
            if(re.code == 200){
              this.guideCoin = re.data.coins;
              this.guideTicket = re.data.tickets;
              this.guideSH = true;
              this.infoStorage('firstNoLogin',1);
            }
            else if(re.code == 401){
              this.toLogin();
            }
            else{
              alert(re.message);
            }
        }).catch((response)=>{
          console.log(response);
        });
      }
    },
    checkLoginGuide(){//检查是否第一次登录
      if(localStorage.getItem('firstLogin') == null){
        this.guideSH2 = true;
        this.infoStorage('firstLogin',1);
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollFn);
    
    // this.$socket.on('connect', function(){
    //   console.log('连接成功');
    // });
	},
  destroyed(){
    window.removeEventListener('scroll', this.scrollFn);
    this.websock.close();
  },
  created(){
  	//控制台查看变量
    //window.vueVar = this;
    var that = this;
    that.checkStorage();

    this.isUserLogin({
        source: this.source[this.curLang],
        platform: 2,
        success: function(data){
            if(data == 1){
                that.ifLogin = true;
                that.refreshInfo();
                that.checkLoginGuide();
            }else{
                /*that.isLoadingShow = false;
                that.gotoLogin();
                return;*/
                that.delStorage('guess_token');
                that.checkNoLoginGuide();
            }
            
            that.loadLx();
            that.getBetSetting();
            that.listLeague();
            that.setFuture();
            that.initWebSocket();
        }
    });
  }
}
</script>

<style scoped>
.popGuide{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1001;background:rgba(0,0,0,0.5)}
.popGuide .p_box{max-width:750px;width:85.3%;position:absolute;top:50%;left:50%;background:#232048;border-radius:16px;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);}
.popGuide .p_box .pb_head{position:absolute;width:89.5%;top:-140px;left:50%;transform:translateX(-50%);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);}
.popGuide .p_box .pb_head img{width:100%;display:block}
.popGuide .p_box .pb_close{width:60px;height:60px;position:absolute;bottom:-82px;left:50%;transform:translateX(-50%);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-o-transform:translateX(-50%);-ms-transform:translateX(-50%);}
.popGuide .p_box .pb_close img{width:100%;display:block}
.popGuide .p_box .pb_title{color:#ffffff;font-size:30px;text-align:center;padding-top:68px;padding-bottom:24px}
.popGuide .p_box .pb_title2{padding-top:20px;padding-bottom:20px;color:#fff;font-size:32px;font-weight:bolder;text-align:center}
.popGuide .p_box .pb_tip{background:#171531;padding-left:26px;padding-right:16px;height:160px;margin:0 46px 22px;border-radius:16px}
.popGuide .p_box .pb_tip .pb_l{width:70px;margin-right:16px}
.popGuide .p_box .pb_tip .pb_l img{width:100%}
.popGuide .p_box .pb_tip .pb_r .pb_p1{color:#fd7446;font-size:36px;font-weight:bolder}
.popGuide .p_box .pb_tip .pb_r .pb_p1_purple{color:#d476e2}
.popGuide .p_box .pb_tip .pb_r .pb_p2{color:#fff;font-size:24px}
.popGuide .p_box .pb_btn{display:block;margin:0 46px 0px;background-color:#6371ea;color:#fff;font-size:30px;text-align:center;height:64px;line-height:64px;border-radius:12px;font-weight:bolder}
.popGuide .p_box .pb_mb{margin-bottom:30px}
.popGuide .p_box .pb_intro{font-size:24px;color:#6371ea;text-align:center;padding-bottom:40px}
.popGuide .p_box .pb_pic{width:60.5%;margin:0 auto 18px}
.popGuide .p_box .pb_pic img{width:100%}

/*错误弹出层*/
.popBox{z-index:600;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);}
.popBox .p_box{border-radius:16px;background:#232048;position:absolute;width:85.3%;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);}
.popBox .p_box .pb_body{height:266px;padding:0 80px;text-align:center}
.popBox .p_box .pb_body p{font-size:30px;color:#fff;text-align:left}
.popBox .p_box .pb_body .pb_success{line-height:80px;padding-left:60px;background:url('../../static/image/icon_success.png') no-repeat left center;background-size:50px;margin:0 auto;display:inline-block;color:#00d9cd;font-size:36px;font-weight:bolder}
.popBox .p_box .pb_body .pb_fail{line-height:80px;padding-left:60px;background:url('../../static/image/icon_fail.png') no-repeat left center;background-size:50px;margin:0 auto;display:inline-block;color:#e74f6b;font-size:36px;font-weight:bolder}
.popBox .p_box .pb_body .pb_tip{padding:30px 30px 0;font-size:24px}
.popBox .p_box .pb_body p>>>span{color:#fd7446;margin:0 10px;font-size:30px}
.popBox .p_box .pb_btn{height:100px;border-top:2px solid #3b3860;font-size:0}
.popBox .p_box .pb_btn a{display:inline-block;color:#fff;font-size:36px;text-align:center;line-height:100px;width:100%}
.popBox .p_box .pb_btn a.on{color:#65637f;border-right:2px solid #3b3860}
.popBox .p_box .pb_btn2 a{width:50%;box-sizing:border-box}
.popBox .p_loading{width:400px;height:360px;text-align:center}
.popBox .p_loading img{width:180px;margin-top:80px;}
.popBox .p_loading p{font-size:30px;color:#fff;padding-top:20px}

/*红点*/
.redPoint{position:relative}
.redPoint:after{top:-10px;right:-10px;position:absolute;display:block;content:'';background:#fb5051;width:20px;height:20px;border-radius:200px}
/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn a{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%)}
.header .h_btn a img{width:28px;height:28px}
/*金币栏*/
.person{position:fixed;z-index:100;top:120px;width:100%;height:280px;background:#131229;padding-top:0}
.personTop{height:116px}
.person .p_box{height:116px;padding:0px 55px;font-size:0;position:relative}
.person .p_box .pb_left{text-align:center;display:inline-block;margin-right:12px}
.person .p_box .pb_left img{display:block;width:40px;height:40px;margin:0 auto}
.person .p_box .pb_left p{color:#bbbabf;font-size:18px;}
.person .p_box .pb_num p{display:inline-block;font-size:30px;color:#fd7446}
.person .p_box .pb_loginBtn a{display:inline-block;vertical-align:top;border-radius:30px;min-width:150px;height:58px;text-align:center;line-height:58px;background:#6371ea;color:#fff;font-size:30px;}
.person .p_box .pb_btn{font-size:0}
.person .p_box .pb_btn a{font-size:18px;margin-left:20px;min-width:50px;display:inline-block;vertical-align: middle;color:#bbbabf;text-align:center}
.person .p_box .pb_btn a img{display:block;width:40px;height:40px;margin:0 auto}
.person .p_box .pb_btn a p{font-size:20px}
.person .p_box .pb_btn a.redPoint:after{top:-4px;right:-4px}
/*轮显*/
.lx{transition:all 0.2s;-webkit-transition:all 0.5s;-moz-transition:all 0.5s;-ms-transition:all 0.5s;-o-transition:all 0.5s;position:fixed;z-index:100;top:236px;left:50%;width:100%;max-width:750px;transform:translateX(-50%);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);}
.lxHide{opacity:0;height:0;overflow:hidden}
.lx .l_box{padding:0 24px}
/*tab栏1*/
.nav1{transition:all .4s;-webkit-transition:all .4s;-moz-transition:all .4s;-ms-transition:all .4s;-o-transition:all .4s;position:fixed;z-index:100;top:500px;left:0;width:100%;background:#171531}
.nav1Top{top:236px;}
.nav1 .n_box{height:126px;padding:0 55px;position:relative}
.nav1 .n_box ul{font-size:0}
.nav1 .n_box ul li{display:inline-block;vertical-align:top;left:0;height:126px;margin-right:50px;position:relative;font-size:36px;color:#bbbabf;line-height:126px;}
.nav1 .n_box ul li:after{display:none;position:absolute;content:'';width:30px;height:6px;background:#00ecfd;border-radius:3px;bottom:16px;left:50%;margin-left:-15px}
.nav1 .n_box ul li.on{color:#fff}
.nav1 .n_box ul li.on:after{display:block}
.nav1 .n_box .nb_btn{position:absolute;top:0;right:0px;height:126px;width:126px;background:url('../../static/image/icon_screen.png') no-repeat center center;background-size:28px}
.nav1 .n_box .nb_btn_on{background-image:url('../../static/image/icon_screen_on.png')}
/*筛选框*/
.screenBox{transition:all .4s;-webkit-transition:all .4s;-moz-transition:all .4s;-ms-transition:all .4s;-o-transition:all .4s;;width:590px;padding-left:50px;position:fixed;z-index:500;top:0;right:0;height:100%;background:#232048}
.screenBoxHide{right:-100%}
.screenBox .s_title{line-height:210px;height:154px;font-size:40px;color:#fff;}
.screenBox .s_btn{height:92px;position:absolute;width:100%;bottom:0;right:0;font-size:0;border-top:2px solid #3b3860}
.screenBox .s_btn a{box-sizing:border-box;line-height:92px;text-align:center;height:92px;display:inline-block;vertical-align:top;width:49.9%;font-size:36px;color:#65637f}
.screenBox .s_btn a.br{border-right:2px solid #3b3860}
.screenBox .s_btn a.on{color:#fff}
.screenBox .s_list{font-size:0;max-height:60%;overflow:auto}
.screenBox .s_list li{box-sizing:border-box;display:inline-block;vertical-align:top;width:90%;height:70px;line-height:70px;background:#3b3860;margin-bottom:18px;margin-right:24px;color:#fff;text-align:center;font-size:24px;}
.screenBox .s_list li.on{border:2px solid #00ecfd;background-image:url('../../static/image/screen_on.png');background-repeat:no-repeat;background-position:top left;background-size:22px}
.screenBox .s_radio{}
.screenBox .s_radio li{position:relative;padding-left:40px;height:80px;line-height:80px;color:#fff;font-size:36px;}
.screenBox .s_radio li.on{color:#00ecfd;background:url('../../static/image/screen_on2.png') no-repeat left center;background-size:16px}
/*购物车*/
.carBg{transition:all .4s;-webkit-transition:all .4s;-moz-transition:all .4s;-ms-transition:all .4s;-o-transition:all .4s;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:200}
.carBgHigher{z-index:400}
.carBgHide{opacity:0;z-index:-10}
.carBox{transition-duration: .4s;overflow:hidden;position:fixed;height:996px;z-index:300;background:#9198a6;left:0;bottom:0;width:100%;border-radius:20px}
.carHide{bottom:-876px}
.carBox .c_header{padding:28px 55px;font-size:0;position:relative}
.carBox .c_header span{display:inline-block;vertical-align:middle}
.carBox .c_header .ch_num{margin-right:20px;width:64px;height:64px;background:#232048;color:#fff;line-height:64px;border-radius:200px;font-size:36px;text-align:center}
.carBox .c_header .ch_txt{position:relative;color:#232048;font-size:30px;}
.carBox .c_header .ch_txt b{position:absolute;left:0;top:36px;color:#cc2829;font-size:20px;width:300px}
.carBox .c_header .ch_btn{border-radius:18px;top:50%;margin-top:-40px;right:55px;position:absolute;width:240px;height:80px;color:#fff;font-size:40px;line-height:80px;text-align:center;background:#6371ea}
.carBox .c_list{padding:0 22px;height:658px;overflow:auto}
.carBox .c_list li{position:relative;background:#3b3860;height:190px;margin-bottom:22px;border-radius:16px;padding-left:84px;}
.carBox .c_list .cl_del{background:#232048 url('../../static/image/icon_del.png') no-repeat center center;background-size:28px 28px;position:absolute;width:60px;height:100%;top:0;left:0;border-top-left-radius:16px;border-bottom-left-radius:16px}
.carBox .c_list .cl_p1{padding-top:24px}
.carBox .c_list .cl_p1 span{display:inline-block;vertical-align:middle}
.carBox .c_list .cl_p1 .cl_handicap{margin-right:10px;font-size:14px;color:#bbbabf;border:2px solid #bbbabf;background:#4f4c70;border-radius:200px;min-width:100px;text-align:center}
.carBox .c_list .cl_p1 .cl_odds{color:#00ecfd;font-size:24px;}
.carBox .c_list .cl_p1 .cl_up,
.carBox .c_list .cl_p1 .cl_down{position:relative}
.carBox .c_list .cl_p1 .cl_up:after,
.carBox .c_list .cl_p1 .cl_down:after{display:block;position:absolute;width:10px;height:20px;content:'';right:-20px;top:50%;margin-top:-10px;background-repeat:no-repeat;background-position:center center;background-size:100% 100%}
.carBox .c_list .cl_p1 .cl_up:after{background-image:url('../../static/image/to_up.png');}
.carBox .c_list .cl_p1 .cl_down:after{background-image:url('../../static/image/to_down.png');}
.carBox .c_list .cl_p2 span{display:inline-block;vertical-align:top;color:#bbbabf;font-size:20px;padding-bottom:6px}
.carBox .c_list .cl_p2 .cl_name{max-width:40%;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.carBox .c_list .cl_p2 .cl_handicap{color:#6371ea;display:none}
.carBox .c_list .cl_p3{font-size:20px;color:#bbbabf;line-height:46px}
.carBox .c_list .cl_p3 span{display:inline-block;vertical-align:middle}
.carBox .c_list .cl_p3 .cl_r{float:right;margin-right:33px;font-size:20px;color:#fd7446;vertical-align:top;line-height:50px}
.carBox .c_list .cl_p3 .cl_r span{font-size:24px;vertical-align:top}
.carBox .c_list .cl_p3 .cl_input{margin-left:6px;color:#fff;font-size:24px;background:#232048;padding-left:20px;padding-right:80px;border-radius:80px}
.carBox .c_list .cl_p4{font-size:20px;color:#fb5051;padding-top:4px}
.carBox .c_total{position:absolute;left:0;width:100%;bottom:0;background:#3c3f59}
.carBox .c_total .ct_txt{font-size:0}
.carBox .c_total .ct_txt div{display:inline-block;vertical-align:top;padding:20px 0}
.carBox .c_total .ct_txt div .p1{color:#bbbabf;font-size:20px;padding-left:55px;width:388px}
.carBox .c_total .ct_txt div .p2{color:#fff;font-size:30px;padding-left:55px;width:388px}
.carBox .c_total .ct_txt div .p3{color:#fd7446;font-size:20px;}
.carBox .c_total .ct_txt div .p4{color:#fd7446;font-size:30px;}
.carBox .c_total .ct_btn{padding:20px;padding-top:0}
.carBox .c_total .ct_btn a{display:block;border-radius:18px;background:#6371ea;color:#fff;text-align:center;height:90px;line-height:90px;font-size:40px;}

.body{padding:626px 22px 120px}
.bodyTop{padding-top:360px}
.nav2{height:76px;background:#232048;border-radius:16px;font-size:0;margin-bottom:30px}
.nav2 li{box-sizing:border-box;font-size:30px;color:#fff;width:49.9%;display:inline-block;vertical-align:top;text-align:center;line-height:76px;line-height:76px}
.nav2 li.br{border-right:2px solid #171531;}
.nav2 li.on{color:#00ecfd}
.nav3{margin-bottom:30px}
.nav3 li{height:76px;border-right:2px solid #171531;background:#232048;}
.nav3 li:nth-child(2){border-top-left-radius:16px;border-bottom-left-radius:16px}
.nav3 li:last-child{border-top-right-radius:16px;border-bottom-right-radius:16px}
.nav3 li p{color:#fff;text-align:center;font-size:30px;line-height:76px}
.nav3 .n_date{background:#171531}
.nav3 .n_date p{color:#bbbabf;width:96px;font-size:24px;line-height:28px;height:auto;font-weight:normal}
.nav3 li.on p{color:#00ecfd}

/*列表*/
.listBox{}
.listBox .l_list{}
.listBox .l_list li{margin-bottom:30px}
.listBox .l_list .l_matchBox{overflow:hidden;/*transition:max-height ease-out 1s;-webkit-transition:max-height ease-out 1s;max-height:3300px*/}
.listBox .l_list .l_matchBoxHide{/*max-height:178px;transition:max-height ease-out .2s;-webkit-transition:max-height ease-out .2s;*/height:174px}
.listBox .l_list .l_match{margin-bottom:4px;}
.listBox .l_list .l_league{background:#232048;border-top-left-radius:16px;border-top-right-radius:16px;padding-left:32px;height:60px;line-height:60px;margin-bottom:6px;color:#6371ea;font-size:24px;}
.listBox .l_list .l_info{height:100px;background:#232048;border-bottom:2px solid #171531;}
.listBox .l_list .l_datetime{padding-left:32px;padding-right:20px;color:#bbbabf;font-size:20px;line-height:30px}
.listBox .l_list .l_team{padding:0}
.listBox .l_list .l_team img,
.listBox .l_list .l_team span{display:inline-block;vertical-align:middle}
.listBox .l_list .l_team img{width:26px;height:26px;border-radius:50%;margin-right:14px}
.listBox .l_list .l_team span{font-size:24px;color:#fff;}
.listBox .l_list .l_type{border-bottom:2px solid #171531;border-right:2px solid #171531;box-sizing:border-box;width:176px;height:76px;color:#bbbabf;font-size:20px;background:#232048}
.listBox .l_list .l_type .lt_handicap{color:#fff;font-weight:bolder;margin-top:-4px}
.listBox .l_list .l_odds{position:relative;box-sizing:border-box;border-bottom:2px solid #171531;border-right:2px solid #171531;box-sizing:border-box;color:#fff;height:76px;font-size:24px;background:#3b3860;font-weight:bolder}
.listBox .l_list .l_odds .lo_select{display:none;background:#232048;position:absolute;top:0;left:0;font-size:14px;color:#00ecfd;padding:0px 16px 4px;border-bottom-right-radius:16px}
.listBox .l_list .l_odds .lo_bet{display:none;position:absolute;top:-2px;left:0;font-size:14px;color:#3b3860;background:#00ecfd url('../../static/image/bet_on.png') no-repeat 2px 30%;background-size:16px;border-bottom-right-radius:16px;padding:0px 16px 4px 24px;}
.listBox .l_list .l_odds .lo_up,
.listBox .l_list .l_odds .lo_down{position:relative;}
.listBox .l_list .l_odds .lo_up:after,
.listBox .l_list .l_odds .lo_down:after{display:block;position:absolute;width:10px;height:20px;content:'';right:-20px;top:50%;margin-top:-10px;background-repeat:no-repeat;background-position:center center;background-size:100% 100%}
.listBox .l_list .l_odds .lo_up:after{background-image:url('../../static/image/to_up.png');}
.listBox .l_list .l_odds .lo_down:after{background-image:url('../../static/image/to_down.png');}
.listBox .l_list .l_select .lo_select{display:block}
.listBox .l_list .l_bet{border:2px solid #00ecfd;height:74px}
.listBox .l_list .l_bet .lo_bet{display:block}
.listBox .l_list .l_sh{border-top:4px solid #171531;height:60px;background:#232048 url('../../static/image/icon_up.png') no-repeat center center;background-size:22px;border-bottom-left-radius:16px;border-bottom-right-radius:16px;}
.listBox .l_list .l_down{background-image:url('../../static/image/icon_down.png')}
.listBox .l_list .l_disable .l_type{background:#1d1a3c;color:#bbbabf;color:#bbbabf}
.listBox .l_list .l_disable .l_type .lt_handicap{color:#4d4b63}
.listBox .l_list .l_disable .l_odds{background:#292648;color:#4d4b63;}
.listBox .l_list .l_disable .l_odds span{font-size:20px}

/*暂无比赛*/
.noMatch{text-align:center;padding:140px 0}
.noMatch img{width:124px}
.noMatch p{font-size:24px;color:#65637f;padding-top:10px}
</style>












// WEBPACK FOOTER //
// src/components/guessList.vue